import React from "react";
import { NavLink } from "react-router-dom";
import "./sidebar.css";
import { Buildings2, Menu, Profile2User } from "iconsax-react";
import { useLocation } from "react-router-dom";
import { Building, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
const Sidenav = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const roleType = localStorage.getItem("role_type"); // Retrieve roleType from localStorage if not in state
  console.log("Received roleType from sidenav--->", roleType);

  const onLogoutHandle = ()=>{
    localStorage.clear()
    dispatch({ type: 'auth/logout' });
    navigate('/loginscreen')

  }

  return (
    <div
      className="sidebar bg-primary text-white p-3 d-flex flex-column"
      style={{ height: "100vh" }}
    >
      <ul className="nav flex-column flex-grow-1">
        <li className="nav-item">
          <NavLink
            to="/dashboard"
            end
            className={({ isActive }) =>
              `nav-link text-white ${isActive ? "active-link" : ""}`
            }
          >
            <span className="icon_nav">
              <Menu size="20" color="#FF8A65" variant="Bold" />
            </span>
            <span className="txt_list_track"> Dashboard </span>
          </NavLink>
        </li>
        {roleType == 2 && (
          <li className="nav-item">
              <NavLink
                to="/companymanagement"
                className={({ isActive }) =>
                  `nav-link text-white ${isActive ? "active-link" : ""}`
                }
              >
                <span>
                  <Buildings2 size="20" color="#FF8A65" variant="Bold" />
                </span>
                <span className="txt_list_track"> Company Management </span>
              </NavLink>
            </li>
        )}
        

        {roleType !== "2" || '4' && (
          <>
            <li className="nav-item">
              <NavLink
                to="/membermanagement"
                className={({ isActive }) =>
                  `nav-link text-white ${isActive ? "active-link" : ""}`
                }
              >
                <span>
                  <Profile2User size="20" color="#FF8A65" variant="Bold" />
                </span>
                <span className="txt_list_track"> Member Management </span>
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink
                to="/marchantmanagement"
                className={({ isActive }) =>
                  `nav-link text-white ${isActive ? "active-link" : ""}`
                }
              >
                <span>
                  <Building size="20" color="#FF8A65" />
                </span>
                <span className="txt_list_track" > Merchant Management </span>
              </NavLink>
            </li>
            <li className="nav-item">
              <NavLink
                to="/adminInfo"
                className={({ isActive }) =>
                  `nav-link text-white ${isActive ? "active-link" : ""}`
                }
              >
                <span>
                  <Buildings2 size="20" color="#FF8A65" variant="Bold" />
                </span>
                <span className="txt_list_track"> Company Management </span>
              </NavLink>
            </li>           
          </>
        )}
      </ul>

      <button
        onClick={onLogoutHandle}
        type="button"
        className="btn btn-danger mt-auto d-flex justify-content-center align-items-center gap-2 w-100"
      >
        Logout
        <LogOut size="18" />
      </button>
    </div>
  );
};

export default Sidenav;
